import { actionCreators } from 'lib/actionCreators'

export const isLoading = actionCreators('IS_LOADING')
export const isLoadingCalendarEvent = actionCreators('IS_LOADING_CALENDAR_EVENT')
export const pageIsLoading = actionCreators('PAGE_IS_LOADING')
export const modalIsLoading = actionCreators('MODAL_IS_LOADING')
export const error403 = actionCreators('ERROR_403')
export const skeleton = actionCreators('SKELETON')
